export const attributesConstants = {
    REQUEST: 'REQUEST_ATTRIBUTES',
    GET: 'GET_ATTRIBUTES',
    GET_ONE: 'GET_ONE',
    FAIL_ONE: 'FAIL_ONE',
    GET_META: 'GET_META',
    GET_COLUMNS: 'GET_COLUMNS',
    FAIL: 'FAIL_ATTRIBUTES'
}; 